export default __webpack_public_path__ + "static/media/r5.78612c82.jpeg";